export default __webpack_public_path__ + "static/media/gs8-app.4d892c21.png";